import { c as _c } from "react/compiler-runtime";
import ProfileAvatar, { ProfileBadgeSize } from "@/components/common/profile/ProfileAvatar";
import { DropPartSize } from "@/components/drops/view/part/DropPart.types";
const AVATAR_SIZE_MAP: Record<DropPartSize, ProfileBadgeSize> = {
  [DropPartSize.SMALL]: ProfileBadgeSize.SMALL,
  [DropPartSize.MEDIUM]: ProfileBadgeSize.MEDIUM,
  [DropPartSize.LARGE]: ProfileBadgeSize.LARGE
};
export default function DropPfp(t0) {
  const $ = _c(3);
  const {
    pfpUrl,
    size
  } = t0;
  const effectiveSize = size ?? DropPartSize.MEDIUM;
  const t1 = AVATAR_SIZE_MAP[effectiveSize];
  let t2;
  if ($[0] !== pfpUrl || $[1] !== t1) {
    t2 = <ProfileAvatar pfpUrl={pfpUrl} size={t1} alt="Create Drop Profile" />;
    $[0] = pfpUrl;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}